import type { ProjectProducer } from '@/api/client';
import type { RecipientUserItem } from '@/components/UserRecipientCombo/UserRecipientCombo';

/** Продюсеры проекта как получатели письма (to). */
export function projectProducersToRecipients(producers: ProjectProducer[] | undefined): RecipientUserItem[] {
  return (producers ?? []).map((p) => ({
    id: p.id,
    name: p.name,
    email: p.email ?? null,
  }));
}
